/**
 * Use this to add css classes reflecting the validation state of a
 * {core/FormField.field} object to any element.
 */
define('ko/customBinding/validationClasses',['knockout'], function(ko) {

    // @todo @dancras Test this
    ko.bindingHandlers.validationClasses = {
        init: function(element, valueAccessor, allBindings, viewModel, bindingContext) {

            var field = valueAccessor();

            ko.applyBindingsToNode(
                element,
                {
                    css: {
                        'is-bad': ko.pureComputed(function() {
                            return field.isShowingErrors() && field.isBad();
                        }),
                        'is-good': field.isGood
                    }
                },
                bindingContext
            );
        }
    };

});

